import React, { createRef } from "react";
import {
  Input,
  Checkbox,
  Radio,
  Space,
  Button,
  Col,
  Row,
  Image,
  Modal,
  Tooltip,
  Select,
  message
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { decode as base64_decode } from "base-64";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import DetailTrackingStore from "../store/DetailTrackingStore";
import dayjs from "dayjs";
import MapForVehiclePosition from "./MapForVehiclePosition";
import Cookies from "js-cookie";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import ShareModalWindow from "./ShareModalWindow";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { CarOutlined } from "@ant-design/icons";
import config from "../config";
import { hasFeature } from "../utils/componentVisibility";
import PythonMessageAlert from "./PythonMessageAlert";

const features = {
  showSweeperColumns: hasFeature("showSweeperColumns"),
  showHumidityColumns: hasFeature("showHumidityColumns")
};
const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (
      val.title === "Location"
    ) {
      val.width = 230;
    } else if (val.dataIndex === "companyName" || val.dataIndex === "vehicleNo") {
      val.width = 190;
    } else if (val.dataIndex === "driverId") {
      val.width = 70;
    } else if (val.dataIndex === "acc" || val.dataIndex === "Share" || val.key === "Maps" || val.dataIndex === "power" || val.dataIndex === "GPS") {
      val.width = 60;
    }
    else if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
    // console.log(val.title.length)
  });

  return arr;
};

class DetailTrackingList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.isadmin = Number(this.props.getUserData().isadmin);
    this.detailTrackingStore = new DetailTrackingStore();
    this.pythonMessageRef = createRef();

    let columns = widthAdderFunc([
      {
        // title: "Company",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_COMPANY_"),
        dataIndex: "companyName",
        width: "10%",
        // fixed: "left",
        key: "companyName",
        ellipsis: {
          showTitle: false,
        },
        render: (companyName) => (
          <Tooltip placement="topLeft" title={companyName}>
            {companyName}
          </Tooltip>
        ),
      },

      {
        // title: "Vehicle No",
        title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
        dataIndex: "vehicleNo",
        width: "10%",
        // fixed: "left",
        key: "vehicleNo",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          // console.log("recrd", record.listImage);
          return (
            <Space>
              {record.listImage && (
                <Image
                  width={30}
                  height={15}
                  src={require(`../assets/images/detailtracking/${record.listImage}`)}
                />
              )}

              {record.vehicleNo}
            </Space>
          );
        },
      },
      {
        // title: "Driver Id",
        title: context.translate("_FLEET_REPORTS_DRIVER_ID_"),
        dataIndex: "driverId",
        key: "driverId",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
      },
      {
        // title: "Vehicle Type",
        title: context.translate("_VEHICLE_TYPE_"),
        dataIndex: "vehicleTypeNew",
        key: "vehicleTypeNew",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Driver Name",
        title: context.translate(
          "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
        ),
        dataIndex: "name",
        key: "name",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%",
      },
      {
        // title: "Location",
        title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"),
        dataIndex: "formatted_address",
        key: "formatted_address",
        ellipsis: {
          showTitle: false,
        },
        render: (formatted_address) => (
          <Tooltip placement="topLeft" title={formatted_address}>
            {formatted_address}
          </Tooltip>
        ),
        // width:"10%",
      },
      {
        // title: "Ignition",
        title: context.translate("_IGNITION_"),
        dataIndex: "acc",
        key: "acc",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%",
        render: (value) => {
          if (value == 1) {
            var img = "IgnitionOn.png";
          } else {
            var img = "IgnitionStop.png";
          }
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/DetailTracking/" +
                  img)}
                width={20}
                height={20}
              />
            </div>
          );
        },
      },
      {
        // title: "Speed(Km)",
        title: context.translate("_SPEED_KM_"),
        dataIndex: "speed",
        key: "speed",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
      },
      {
        title: context.translate("_FLEET_DASHBORD_RULETRIGGER_TIME_"),
        dataIndex: "updatedate",
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          if (config.pythonReport === 1) {
            return val
          } else {
            return dayjs.utc(val).format("DD-MM-YYYY h:mm:ss A");
          }
        },
        key: "updatedate",
        // width:"10%"
      },
      {
        // title: "GPS",
        title: context.translate("_GPS_"),
        dataIndex: "GPS",
        key: "GPS",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
        render: (value) => {
          if (value == 1) {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Image
                  src={require("../assets/images/NewDesign/DetailTracking/GPSRed.png")}
                  width={20}
                  height={20}
                />
              </div>
            );
          } else {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Image
                  src={require("../assets/images/NewDesign/DetailTracking/GPSGreen.png")}
                  width={20}
                  height={20}
                />
              </div>
            );
          }
        },
      },
      {
        // title: "Alert",
        title: context.translate("_FLEET_ALERT_"),
        dataIndex: "power",
        key: "alert",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%",
        render: (value) => {
          if (value == 1) {
            var img = "AlertRed.png";
          } else {
            var img = "AlertGreen.png";
          }
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/DetailTracking/" +
                  img)}
                width={20}
                height={20}
              />
            </div>
          );
        },
      },
      {
        // title: "Alert",
        title: context.translate("_POWER_"),
        dataIndex: "power",
        key: "power",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%",
        render: (value) => {
          if (value == 1) {
            var img = "PowerRed.png";
          } else {
            var img = "PowerGreen.png";
          }
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/DetailTracking/" +
                  img)}
                width={20}
              // height={20}
              />
            </div>
          );
        },
      },
      {
        // title: "Odometer",
        title: context.translate("_FLEET_DASHBORD_SETTING_ODOMETER_"),
        dataIndex: "distance",
        key: "distance",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
      },
      {
        title: context.translate("_FUEL_"),
        dataIndex: "fuelHeight1",
        key: "fuelHeight1",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_LEFT_SWEEPER_"),
        dataIndex: "leftsweeper",
        key: "leftsweeper",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => (
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: value === "on" ? "green" : "red",
              margin: "auto",
            }}
          />
        ),
      },
      {
        title: context.translate("_RIGHT_SWEEPER_"),
        dataIndex: "rightsweeper",
        key: "rightsweeper",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => (
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: value === "on" ? "green" : "red",
              margin: "auto",
            }}
          />
        ),
      },
      {
        // title: "Maps",
        title: context.translate("_FLEET_SERVICE_POILIST_MAP_"),
        // dataIndex: "Maps",
        key: "Maps",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
        render: (value) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",

              }}
            >
              <Image
                src={require("../assets/images/NewDesign/DetailTracking/MapIcon.png")}
                width={17}
                style={{ cursor: 'pointer' }}
                onClick={() => {

                  this.setState({ vehicleObj: value });
                }}
              />
            </div>
          );
        },
      },
      {
        title: context.translate("_FLEET_SERVICE_POILIST_SHARE_"),
        dataIndex: "Share",
        key: "Share",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%",
        render: (value, record) => {
          let data = [];
          data.push(`${Number(record.latitude)},${Number(record.longitude)}`);

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/DetailTracking/ShareIcon.png")}
                width={15}
                onClick={() => {
                  this.setState({ shareModalVisible: data });
                }}
              />
            </div>
          );
        },
      },
    ])

    if (!features.showSweeperColumns) {
      columns = columns.filter(
        (val) =>
          val.dataIndex !== "leftsweeper" &&
          val.dataIndex !== "rightsweeper"
      );
    }
    this.state = {
      offset: "",
      limit: "",
      status: "normal",
      loading: false,
      exportLoading: false,
      pageSize: 50,
      currentPage: 1,
      NoData: "",
      Normal: "",
      Idle: "",
      // Moving: "",
      Running: "",
      Stopped: "",
      searchvod: "",
      show: false,
      modalVisible: false,
      column: "",
      vehicleObj: false,
      shareModalVisible: false,
      searchField: "",
      isAllVehicle: false,
      reportmessage: "",
      selectedColumns: columns,
      isCanbus: 0,
      cityName: "",
    };


    this.newColumns = widthAdderFunc([
      ...this.state.selectedColumns,
      {
        title: context.translate("_VEHICLEID_"),
        dataIndex: "vehicleId",
        key: "vehicleId",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_DASHBORD_MAP_SATELLITE_"),
        dataIndex: "GSMSignal",
        key: "GSMSignal",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Load Voltage",
        title: context.translate("_LOAD_VOLTAGE_"),
        dataIndex: "loadVoltage",
        key: "loadVoltage",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Total Weight(kg)",
        title: context.translate("_TOTAL_TRUCK_WEIGHT_"),
        dataIndex: "totalWeight",
        key: "totalWeight",
        ellipsis: {
          showTitle: true,
        },
        render: (value, c, r) => {
          // console.log(r, c);
          var loadVoltage = c.loadVoltage;
          var weightFactor = c.weightFactor;

          if (loadVoltage != null && weightFactor != null) {
            //r.get('totalWeight') is v.weightFactor
            var loadKg = loadVoltage * weightFactor;

            if (loadKg > c.emptyWeight) {
              return Math.round(loadKg);
            } else {
              return Math.round(c.emptyWeight);
            }
          } else {
            return "NA";
          }
        },
      },
      {
        // title: "BLE Temp",
        title: context.translate("_BLE_TEMP_"),
        dataIndex: "BLETemp",
        key: "bleTemp",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (!value || value === "") {
            return "NA";
          }

          // Split by comma (with or without space)
          const arr = value.split(",").map((v) => v.trim());
          const formatted = [];

          for (let i = 0; i < arr.length; i++) {
            if (!arr[i] || arr[i] === "NA") continue;

            // NEW FORMAT → sensorId:value
            if (arr[i].includes(":")) {
              const [sensorId, sensorValue] = arr[i].split(":");

              formatted.push(
                <div key={i}>
                  <b>{`Sensor ${sensorId} : `}</b>
                  {sensorValue}
                </div>
              );
            }
            // OLD FORMAT → just value
            else {
              formatted.push(
                <div key={i}>
                  <b>{`Sensor ${i + 1} : `}</b>
                  {arr[i]}
                </div>
              );
            }
          }

          return formatted.length ? formatted : "NA";
        },
      },
      {
        // title: "BLE Humidity",
        title: context.translate("_BLE_HUMIDITY_"),
        dataIndex: "BLEHumidity",
        key: "bleHumidity",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (!value || value === "") {
            return "NA";
          }

          // Split by comma (with or without space)
          const arr = value.split(",").map((v) => v.trim());
          const formatted = [];

          for (let i = 0; i < arr.length; i++) {
            if (!arr[i] || arr[i] === "NA") continue;

            // NEW FORMAT → sensorId:value
            if (arr[i].includes(":")) {
              const [sensorId, sensorValue] = arr[i].split(":");

              formatted.push(
                <div key={i}>
                  <b>{`Sensor ${sensorId} : `}</b>
                  {sensorValue}
                </div>
              );
            }
            // OLD FORMAT → just value
            else {
              formatted.push(
                <div key={i}>
                  <b>{`Sensor ${i + 1} : `}</b>
                  {arr[i]}
                </div>
              );
            }
          }

          return formatted.length ? formatted : "NA";
        },
      },

      {
        // title: "IMEI ",
        title: context.translate("_FLEET_DASHBORD_SETTING_IMEI_"),
        dataIndex: "full_imei",
        key: "imei",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "SIM No ",
        title: context.translate("_SIM_NO_"),
        dataIndex: "simNo",
        key: "simNo",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Temp1",
        title: context.translate("_FLEET_DASHBORD_SETTING_TEMP1_"),
        dataIndex: "temp1",
        key: "temp1",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
      },
      {
        // title: "Temp2",
        title: context.translate("_FLEET_DASHBORD_SETTING_TEMP2_"),
        dataIndex: "temp2",
        key: "temp2",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
      },
      {
        // title: "Temp3",
        title: context.translate("_FLEET_DASHBORD_SETTING_TEMP3_"),
        dataIndex: "temp3",
        key: "temp3",
        ellipsis: {
          showTitle: true,
        },
        // width:"10%"
      },
      ...(features.showHumidityColumns ? [{
        title: context.translate("_HUMIDITY_1"),
        dataIndex: "spare6",
        key: "spare6",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_HUMIDITY_2"),
        dataIndex: "spare7",
        key: "spare7",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_HUMIDITY_3"),
        dataIndex: "spare8",
        key: "spare8",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FRONT_PASSENGER_"),
        dataIndex: "input3",
        key: "input3",
        render: (value) => (
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: Number(value) === 1 ? "green" : "red",
              margin: "auto",
            }}
          />
        ),
      },
      {
        title: context.translate("_REAR_BEHIND_PASSENGER_"),
        dataIndex: "sensorId1",
        key: "sensorId1",
        render: (value) => (
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: Number(value) === 1 ? "green" : "red",
              margin: "auto",
            }}
          />
        ),
      },
      {
        title: context.translate("_REAR_MIDDLE_"),
        dataIndex: "sensorId2",
        key: "sensorId2",
        render: (value) => (
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: Number(value) === 1 ? "green" : "red",
              margin: "auto",
            }}
          />
        ),
      },
      {
        title: context.translate("_REAR_BEHIND_DRIVER_"),
        dataIndex: "sensorId3",
        key: "sensorId3",
        render: (value) => (
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: Number(value) === 1 ? "green" : "red",
              margin: "auto",
            }}
          />
        ),
      }
      ] : [])
    ]);
  }
  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      console.log("ilocasd");
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }

  async componentDidMount() {

    const searchField_dt_session = sessionStorage?.getItem('searchField_dt_session');
    // console.log(searchField_dt_session)
    if (searchField_dt_session) {
      const { searchField } = JSON.parse(searchField_dt_session);
      this.setState({ searchField });
    }



    const company_value_label_dt_session = sessionStorage?.getItem('company_value_label_dt_session');

    if (company_value_label_dt_session) {
      const { company_value_label } = JSON.parse(company_value_label_dt_session);
      this.setState({ company_value_label });
      // console.log(company_value_label.value)
      await this.setState({ companyId: company_value_label.value });
      await this.handleSearch();
    }

    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    // await this.detailTrackingStore.loadData({ offset: 0, limit: 50 });
    await this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });
  }
  async handleChange(comp) {
    console.log(comp);
    if (comp) {
      await this.setState({
        companyId: comp ? comp?.value : null,
        currentPage: 1,
        status: "normal",
      });
      await this.handleSearch();
    } else {
      await this.setState({
        companyId: null,
      });
      this.detailTrackingStore.trackData = [];
      this.detailTrackingStore.totalVehicalState = [];
      this.detailTrackingStore.total = 0;
      this.setState({ loadData: 1 });
    }
  }

  handleCheckboxChange = async (column) => {
    console.log(column);

    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });

      // await  this.updateVisibleColumns();
    }
  };

  callingMethod = async () => {
    await this.detailTrackingStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      status: this.state.status,
      isCanbus: this.state.isCanbus,
      searchField: this.state.searchField,
      cityName: this.state.cityName,
      userCompany: this.props.getUserData().userCompanyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
    });

    await this.setState({ loadData: 1 });

    // Clear previous timeout if it exists
    if (this.trackingTimeout) {
      clearTimeout(this.trackingTimeout);
    }

    this.trackingTimeout = setTimeout(() => {
      this.callingMethod();
    }, 60000);
  };

  componentWillUnmount() {
    if (this.trackingTimeout) {
      clearTimeout(this.trackingTimeout);
    }
  }

  async handleSearch() {
    if (this.state.companyId) {
      this.callingMethod();
    }
  }
  searchInput = async (e) => {
    if (e === 0 && this.state.companyId) {


      this.setState({ loading: true });
      await this.detailTrackingStore.loadData({
        // offset: (this.state.currentPage - 1) * this.state.pageSize,
        offset: 0,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        status: this.state.status,
        isCanbus: this.state.isCanbus,
        cityName: this.state.cityName,
        searchField: this.state.searchField,
        userCompany: this.props.getUserData().userCompanyId,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        //   vehicleNo:this.state.vehicleNo,
        //   driver:this.state.driver
      });
      await this.setState({ currentPage: 1, loading: false });
    } else {
      const value = e.target.value;

      sessionStorage.setItem('searchField_dt_session', JSON.stringify({
        searchField: e.target.value
      }));

      // await this.setState({searchField:value})
      if (value.length > 2 && this.state.companyId) {
        await this.detailTrackingStore.loadData({
          offset: 0,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          status: this.state.status,
          isCanbus: this.state.isCanbus,
          cityName: this.state.cityName,
          searchField: this.state.searchField,
          userCompany: this.props.getUserData().userCompanyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,
          //   vehicleNo:this.state.vehicleNo,
          //   driver:this.state.driver
        });
        await this.setState({ loadData: 1 });
        await this.setState({ currentPage: 1, loading: false });

        await this.setState({ loadList: 1 });
      } else if (value.length === 0 && this.state.companyId) {
        await this.detailTrackingStore.loadData({
          offset: 0,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          status: this.state.status,
          isCanbus: this.state.isCanbus,
          cityName: this.state.cityName,
          searchField: "",
          userCompany: this.props.getUserData().userCompanyId,
          isadmin: this.props.getUserData().isadmin,
          //   vehicleNo:this.state.vehicleNo,
          //   driver:this.state.driver
        });
        await this.setState({ currentPage: 1 });
      }
    }
  };

  exportFuncClick = async () => {
    const result = [];

    this.state.selectedColumns?.map((obj) => {
      result.push(obj.dataIndex);
    });
    this.setState({ exportLoading: true });
    //  console.log(result.toString())
    // vehicleNo=&driver=&status=searchvod&userId=1
    var getData = {
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      cid: this.state.companyId == -1 ? 0 : this.state.companyId,
      colList: result,
      searchField: this.state.searchField,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      status: this.state.status,
      isCanbus: this.state.isCanbus,
      cityName: this.state.cityName,
      userId: this.props.getUserData().userId,
    };

    try {

      const response = await this.detailTrackingStore.exportExcel(getData);

      if (response.data.success == "S") {
        await this.setState({ reportmessage: "success" })
      } else {
        await this.setState({ reportmessage: "error" })
      }
      await this.triggerReport();

    } catch (error) {
      message.error("Failed to export Excel");
      this.setState({ exportLoading: false });
    } finally {
      this.setState({ exportLoading: false });
    }

  };

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  render() {
    return (
      <>
        <div className="listHeader">
          {/* <Row className="listInputRow"> */}
          {/* <Space>
              <Radio.Group
                onChange={async (e) => {
                  await this.setState({ status: e.target.value });
                  await this.handleSearch();
                }}
              >
                <Space>
                  <Radio.Button
                    title=""
                    value={"Stop"}
                    style={{ color: "black", backgroundColor: "#EF5350" }}
                    onClick={() => this.setState({ currentPage: 1, offset: 0 })}
                  >
                    {this.context.translate("_STOPPED_")}{" "}
                    {this.detailTrackingStore.totalVehicalState?.Stopped}
                  </Radio.Button>
                  <Radio.Button
                    value={"Running"}
                    style={{ color: "black", backgroundColor: "#66BB6A" }}
                    onClick={() => this.setState({ currentPage: 1, offset: 0 })}
                  >
                    {this.context.translate("_RUNNING_")}{" "}
                    {this.detailTrackingStore.totalVehicalState?.Moving}
                  </Radio.Button>
                  <Radio.Button
                    value={"Idle"}
                    style={{ color: "black", backgroundColor: "#FFEE58" }}
                    onClick={() => this.setState({ currentPage: 1, offset: 0 })}
                  >
                    {this.context.translate("_IDLE_")}{" "}
                    {this.detailTrackingStore.totalVehicalState?.Idle}
                  </Radio.Button>
                  <Radio.Button
                    value={"powerCut"}
                    style={{ color: "black", backgroundColor: "#03A9F4" }}
                    onClick={() => this.setState({ currentPage: 1, offset: 0 })}
                  >
                    {" "}
                    {this.context.translate("_POWER_CUT_")}{" "}
                    {this.detailTrackingStore.totalVehicalState?.PowerCut}
                  </Radio.Button>

                  <Radio.Button
                    value={"NoData"}
                    style={{ color: "black", backgroundColor: "#839192" }}
                    onClick={() => this.setState({ currentPage: 1, offset: 0 })}
                  >
                    {this.context.translate("_NoData_")}{" "}
                    {this.detailTrackingStore.totalVehicalState?.NoData}
                  </Radio.Button>
                  <Radio.Button
                    value={"normal"}
                    style={{ color: "black", backgroundColor: "#D0D3D4" }}
                    onClick={() => this.setState({ currentPage: 1, offset: 0 })}
                  >
                    {this.context.translate("_ALL_")}{" "}
                    {this.detailTrackingStore.totalVehicalState?.allStatusCount}
                  </Radio.Button>
                </Space>
              </Radio.Group>

              <CompanyAutocomplete
                className="searchInput"
                showAll={1}
                allowClear={true}
                onChange={(value) => this.handleChange(value)}
                style={{ width: 200 }}
              />

              <Input
                placeholder={this.context.translate(
                  "_SEARCH_BY_DRIVER_VEHICLE_"
                )}
                style={{ width: 200, borderRadius: "25px" }}
                onChange={async (e) => {
                  await this.setState({ searchField: e.target.value });
                  await this.searchInput(e);
                  // await this.setState({ status: "searchvod" });
                }}
              />

              <Button onClick={() => this.setState({ modalVisible: true })}>
                {this.context.translate("_COLUMNS_")}
              </Button>
            </Space> */}
          {/* <Space
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.searchInput(0)}
                ></Image>
              </Tooltip>
              <Tooltip
                title={this.context.translate("_DOWNLOAD_")}
                placement="bottom"
              >
                <span>
                  <Button
                    className="downloadExcelButton"
                    disabled={
                      this.detailTrackingStore?.trackData?.length > 0
                        ? false
                        : true
                    }
                    onClick={() => this.exportFuncClick()}
                  >
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Button>
                </span>
              </Tooltip>
            </Space>
          </Row> */}

          <Row className="listInputRow">
            <Space>
              <div
                className={`dt-status-stop ${this.state.status === "normal" ? "dt-active" : ""}`}
                onClick={async () => {
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "normal", currentPage: 1, offset: 0, isCanbus: 0, cityName: "", loading: true },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false })
                }}
              >
                <div className="dt-icon-section dtall">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/all.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {this.context.translate("_ALL_")}{" "}
                  </span>
                  <span className="dt-count">
                    {/*{this.detailTrackingStore.total
                      ? this.detailTrackingStore.total
                      : 0}*/}
                    {this.detailTrackingStore.totalVehicalState?.actualTotalCount
                      ? this.detailTrackingStore.totalVehicalState?.actualTotalCount
                      : this.detailTrackingStore.total}
                  </span>
                </div>
              </div>

              <div
                className={`dt-status-stop ${this.state.status === "Running" ? "dt-active" : ""}`}
                onClick={async () => {
                  // this.setState({
                  //   status: "Running",
                  //   currentPage: 1,
                  //   offset: 0,
                  // });
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "Running", currentPage: 1, offset: 0, isCanbus: 0, cityName: "", loading: true },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false })
                }}
              >
                <div className="dt-icon-section dtrunning">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/running.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {" "}
                    {this.context.translate("_RUNNING_")}{" "}
                  </span>
                  <span className="dt-count">
                    {" "}
                    {this.detailTrackingStore.totalVehicalState?.Moving
                      ? this.detailTrackingStore.totalVehicalState?.Moving
                      : 0}{" "}
                  </span>
                </div>
              </div>

              <div
                className={`dt-status-stop ${this.state.status === "Stop" ? "dt-active" : ""}`}
                onClick={async () => {
                  // this.setState({
                  //   status: "Stop",
                  //   currentPage: 1,
                  //   offset: 0,
                  // });
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "Stop", currentPage: 1, offset: 0, isCanbus: 0, cityName: "", loading: true },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false })
                }}
              >
                <div className="dt-icon-section dtstopped">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/stopped.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {" "}
                    {this.context.translate("_STOPPED_")}{" "}
                  </span>
                  <span className="dt-count">
                    {" "}
                    {this.detailTrackingStore.totalVehicalState?.Stopped
                      ? this.detailTrackingStore.totalVehicalState?.Stopped
                      : 0}
                  </span>
                </div>
              </div>

              <div
                className={`dt-status-stop ${this.state.status === "Idle" ? "dt-active" : ""}`}
                onClick={async () => {
                  // this.setState({
                  //   status: "Idle",
                  //   currentPage: 1,
                  //   offset: 0,
                  // });
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "Idle", currentPage: 1, offset: 0, isCanbus: 0, cityName: "", loading: true },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false })
                }}
              >
                <div className="dt-icon-section dtidle">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/idle.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {this.context.translate("_IDLE_")}{" "}
                  </span>
                  <span className="dt-count">
                    {this.detailTrackingStore.totalVehicalState?.Idle
                      ? this.detailTrackingStore.totalVehicalState?.Idle
                      : 0}
                  </span>
                </div>
              </div>

              <div
                className={`dt-status-stop ${this.state.status === "powerCut" ? "dt-active" : ""}`}
                onClick={async () => {
                  // this.setState({
                  //   status: "powerCut",
                  //   currentPage: 1,
                  //   offset: 0,
                  // });
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "powerCut", currentPage: 1, offset: 0, isCanbus: 0, cityName: "", loading: true },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false })
                }}
              >
                <div className="dt-icon-section dtpowercut">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/power-cut.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {" "}
                    {this.context.translate("_POWER_CUT_")}{" "}
                  </span>
                  <span className="dt-count">
                    {this.detailTrackingStore.totalVehicalState?.PowerCut
                      ? this.detailTrackingStore.totalVehicalState?.PowerCut
                      : 0}
                  </span>
                </div>
              </div>

              <div
                className={`dt-status-stop ${this.state.status === "NoData" ? "dt-active" : ""}`}
                onClick={async () => {
                  // this.setState({
                  //   status: "NoData",
                  //   currentPage: 1,
                  //   offset: 0,
                  // });
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "NoData", currentPage: 1, offset: 0, isCanbus: 0, cityName: "", loading: true },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false });
                }}
              >
                <div className="dt-icon-section dtnodata">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/no-data.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {this.context.translate("_NoData_")}{" "}
                  </span>
                  <span className="dt-count">
                    {" "}
                    {this.detailTrackingStore.totalVehicalState?.NoData
                      ? this.detailTrackingStore.totalVehicalState?.NoData
                      : 0}
                  </span>
                </div>
              </div>

              <div
                className={`dt-status-stop ${this.state.status === "neverreported" ? "dt-active" : ""}`}
                onClick={async () => {
                  // this.setState({
                  //   status: "NoData",
                  //   currentPage: 1,
                  //   offset: 0,
                  // });
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "neverreported", currentPage: 1, offset: 0, isCanbus: 0, cityName: "", loading: true },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false });
                }}
              >
                <div className="dt-icon-section dtnotreported">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/not-reported.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {this.context.translate("_NOT_REPORTED_")}{" "}
                  </span>
                  <span className="dt-count">
                    {" "}
                    {this.detailTrackingStore.totalVehicalState?.NeverReported
                      ? this.detailTrackingStore.totalVehicalState?.NeverReported
                      : 0}
                  </span>
                </div>
              </div>
              <div
                className={`dt-status-stop ${this.state.status === "Canbus" ? "dt-active" : ""}`}
                onClick={async () => {
                  // this.setState({
                  //   status: "NoData",
                  //   currentPage: 1,
                  //   offset: 0,
                  // });
                  await new Promise((resolve) =>
                    this.setState(
                      { status: "Canbus", currentPage: 1, offset: 0, isCanbus: 1, cityName: "", loading: true, },
                      resolve // callback after setState is done
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false });
                }}
              >
                <div className="dt-icon-section dtcanbus">
                  <Image
                    src={require("../assets/images/NewDesign/DetailTracking/canbus.png")}
                  />
                </div>
                <div className="dt-info-section">
                  <span className="dt-title">
                    {this.context.translate("_CANBUS_")}{" "}
                  </span>
                  <span className="dt-count">
                    {" "}
                    {this.detailTrackingStore.totalVehicalState?.Canbus
                      ? this.detailTrackingStore.totalVehicalState?.Canbus
                      : 0}
                  </span>
                </div>
              </div>

              <CompanyAutocomplete
                className="searchInput"
                showAll={1}
                allowClear={true}
                onChange={(value) => {
                  this.handleChange(value)
                  sessionStorage.setItem('company_value_label_dt_session', JSON.stringify({
                    company_value_label: value
                  }));
                }}
                style={{ width: 160 }}
                value={
                  this.state.company_value_label
                    ? this.state.company_value_label
                    : null
                }
              />

              <Input
                placeholder={this.context.translate(
                  "_SEARCH_BY_DRIVER_VEHICLE_"
                )}
                style={{ width: 170, borderRadius: "25px" }}
                value={this.state.searchField}
                onChange={async (e) => {
                  await this.setState({ searchField: e.target.value });
                  await this.searchInput(e);
                  // await this.setState({ status: "searchvod" });
                }}
              />

              <Select
                className="searchInput"
                style={{
                  width: 110,
                }}
                allowClear
                value={this.state.cityName ? this.state.cityName : null}
                onChange={async (val) => {
                  await new Promise((resolve) =>
                    this.setState(
                      { cityName: val !== undefined ? val : "", currentPage: 1, offset: 0, loading: true },
                      resolve
                    )
                  );
                  await this.handleSearch();
                  this.setState({ loading: false });
                }}
                placeholder={this.context.translate("_CITY_NAME_")}

                options={[
                  { value: "", label: this.context.translate("_ALL_") },
                  { value: "Riyadh", label: this.context.translate("_RIYADH_") },
                  { value: "Jeddah", label: this.context.translate("_JEDDAH_") },
                  { value: "Mecca", label: this.context.translate("_MECCA_") },
                  { value: "Medina", label: this.context.translate("_MEDINA_") },
                  { value: "Dammam", label: this.context.translate("_DAMMAM_") },
                  { value: "Khobar", label: this.context.translate("_KHOBAR_") },
                  { value: "Dhahran", label: this.context.translate("_DHAHRAN_") },
                  { value: "Taif", label: this.context.translate("_TAIF_") },
                  { value: "Abha", label: this.context.translate("_ABHA_") },
                  { value: "Tabuk", label: this.context.translate("_TABUK_") },

                ]}
              />
              <Button onClick={() => this.setState({ modalVisible: true })}>
                {this.context.translate("_COLUMNS_")}
              </Button>
            </Space>

            <Space
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.searchInput(0)}
                ></Image>
              </Tooltip>
              <Tooltip
                title={this.context.translate("_DOWNLOAD_")}
                placement="bottom"
              >
                <span>
                  <Button
                    className={`downloadExcelButton ${this.state.exportLoading ? "downloadExcelButtonLoading" : ""
                      }`}
                    loading={this.state.exportLoading}
                    disabled={
                      this.detailTrackingStore?.trackData?.length > 0
                        ? false
                        : true
                    }
                    onClick={() => this.exportFuncClick()}
                  >
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Button>
                </span>
              </Tooltip>
            </Space>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.detailTrackingStore?.statusTotalCount}
            //total={this.detailTrackingStore?.total}
            // statusTotalCount={this.detailTrackingStore?.statusTotalCount}
            columns={this.state.column}
            pageSize={this.state.pageSize}
            dataSource={this.detailTrackingStore?.trackData}
            loading={this.state.loading || this.detailTrackingStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          open={this.state.modalVisible}
          width={300}
          // title="Select Columns"
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          onOk={() => {
            this.setState({ modalVisible: false });
          }}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {this.newColumns.map((column, v) => {
              if (this.props.getUserData().isadmin === 1) {
                if (
                  column.dataIndex !== "simNo" &&
                  column.dataIndex !== "full_imei"
                ) {
                  return (
                    <Row key={v}>
                      <Col>
                        <Checkbox
                          onChange={() => this.handleCheckboxChange(column)}
                          checked={this.state.selectedColumns.some(
                            (c) => c.key === column.key
                          )}
                        >
                          {column.title}
                        </Checkbox>
                      </Col>
                    </Row>
                  );
                }
              } else {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              }
            })}
          </div>
        </Modal>

        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }

        {this.state.vehicleObj && (
          <MapForVehiclePosition
            vehicleObj={this.state.vehicleObj}
            heading={this.context.translate("_DETAIL_TRACKING_MAP_")}
            closeMapModal={(resp) => {
              this.setState({ vehicleObj: resp });
            }}
          />
        )}

        {this.state.shareModalVisible && (
          <ShareModalWindow
            shareModalCloseFunc={(resp) =>
              this.setState({ shareModalVisible: resp })
            }
            shareSingleLocation={this.state.shareModalVisible}
          />
        )}
      </>
    );
  }
}
DetailTrackingList.contextType = StoreContext;
export default observer(withRouter(DetailTrackingList));
